import { useApiGetQuery } from 'utils/queryClient'

export const unassignedDesktopDevicesQueryKey = ['devices', 'desktop', 'unassigned']

const isUnassignedDevice = device => device.user === null || device.user === undefined

const useUnassignedDesktopDevices = (options = {}) =>
  useApiGetQuery({
    defaultValue: [],
    endpoint: '/devices?type=desktop',
    queryKey: unassignedDesktopDevicesQueryKey,
    options: {
      select: devices => (devices || []).filter(isUnassignedDevice),
      ...options,
    },
  })

export default useUnassignedDesktopDevices
